export const pauseReason =
{
    0: "",
    1: "device.status.pause-reason.no-material",
    2: "common.unknown"
}